// components/ProfileAddress.jsx
import { AGE_TEXT_QUEST } from 'app/config/constants';
import React from 'react';
import { Translate } from 'react-jhipster';
import { Row, Col } from 'reactstrap';

const ProfileAddress = ({ country, state, userProfileEntity }) => {
  return (
    <>
      <hr />
      <Row className="pt-3">
        <Col sm="12">
          <h3>Address</h3>
        </Col>

        <Col sm="3 border-end border-light">
          <dt>
            <span id="zipCode">
              <Translate contentKey="fivePlusApp.userProfile.zipCode">Zip Code</Translate>
            </span>
          </dt>
          <dd className="fw-medium">{userProfileEntity[0]?.zipCode}</dd>
        </Col>
        <Col sm="3 border-end border-light ps-4">
          <dt>
            <span id="instagramUrl">
              <span>Instagram Id</span>
            </span>
          </dt>

          <dd className="fw-medium">{userProfileEntity[0]?.instagramUrl}</dd>
        </Col>
        <Col sm="6 ps-4">
          <dt>
            <span id="personalInfoLink">
              <span>Personal Info Link</span>
            </span>
          </dt>

          <dd className="fw-medium">
            {userProfileEntity[0]?.personalInfoLink?.split(',').map((link, index, array) => (
              <div key={index} className="mb-2 d-flex d-nowrap">
                <a href={link.trim()} target="_blank" rel="noopener noreferrer" className="text-truncate d-block">
                  {link.trim()}
                </a>
                {index < array.length - 1 && ' , '}
              </div>
            ))}
          </dd>
        </Col>
      </Row>

      <hr></hr>
      <Row className="pb-3 pt-3">
        <dt>
          <span id="selfDescription">
            <h3 className="pt-3">Self Description</h3>
          </span>
        </dt>
        <dd className="fw-medium">
          {userProfileEntity && userProfileEntity[0] ? (
            <Row className="counter-row">
              {Object.entries(userProfileEntity[0]).map(([key, value], ind) => {
                if (key.startsWith('selfDescription') && value) {
                  const year = key.slice(-2);
                  return (
                    <Col sm="6" className="pb-3">
                      <div key={key}>
                        <dt className="decade-title"> {`${AGE_TEXT_QUEST}${year}'s`} </dt>
                        <div className="decade-text fw-normal">{value as React.ReactNode}</div>
                      </div>
                    </Col>
                  );
                }
                return null;
              })}
            </Row>
          ) : (
            'No self-description available'
          )}
        </dd>
      </Row>
      <Row className="pb-3 pt-3 mb-3">
        <Col className="sm-12">
          <div className="community-card">
            <dt>
              <span id="helpCommunityDescription" className="mb-1 d-block">
                <span>Community Engagement & 5 Causes to Support/Non Profits</span>
              </span>
            </dt>
            <dd className="fw-normal">{userProfileEntity[0]?.helpCommunityDescription}</dd>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ProfileAddress;
